module.exports = __webpack_public_path__ + "img/img_portfolio2.74889e8f.jpg";